// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AXGr","placeholdersHeader":"styles_placeholdersHeader__29LxX","editorStyle":"styles_editorStyle__3HvQ7","placeholdersBox":"styles_placeholdersBox__1nDXy"};